import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { ShieldCheck, Users, Globe, Target, Lightbulb, Handshake } from '@phosphor-icons/react';

const values = [
  { icon: <Lightbulb size={36} weight="duotone" className="text-[#0052FF]" />, title: 'Innovation', description: 'We leverage cutting-edge technologies including AI, automation, and cloud-native solutions to keep our clients ahead of the curve.' },
  { icon: <ShieldCheck size={36} weight="duotone" className="text-[#0052FF]" />, title: 'Reliability', description: 'Our 99.99% uptime SLA and 24/7 enterprise support ensure your mission-critical systems are always operational.' },
  { icon: <Target size={36} weight="duotone" className="text-[#0052FF]" />, title: 'Precision', description: 'Every solution is architected with meticulous attention to detail, ensuring optimal performance and cost efficiency.' },
  { icon: <Users size={36} weight="duotone" className="text-[#0052FF]" />, title: 'Client-Centric', description: 'We build deep partnerships with our clients, understanding their unique challenges and delivering tailored solutions.' },
  { icon: <Globe size={36} weight="duotone" className="text-[#0052FF]" />, title: 'Global Reach', description: 'With operations in the USA and India, we provide follow-the-sun support and globally distributed infrastructure.' },
  { icon: <Handshake size={36} weight="duotone" className="text-[#0052FF]" />, title: 'Transparency', description: 'Granular reporting and real-time dashboards ensure complete visibility into your cloud operations and spending.' },
];

export default function AboutPage() {
  return (
    <div className="min-h-screen bg-white" data-testid="about-page">
      <Header />
      <div className="pt-[72px]">
        {/* Hero */}
        <div className="bg-[#0B132B] py-20 md:py-28">
          <div className="w-full px-6 md:px-10 lg:px-16 xl:px-24">
            <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#10B981] mb-3">About Us</p>
            <h1 className="text-4xl sm:text-5xl tracking-tighter font-black text-white" style={{ fontFamily: 'Chivo, sans-serif' }}>
              Who We Are
            </h1>
            <p className="text-lg md:text-xl text-slate-300 mt-4 max-w-3xl" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
              AIAURORA TECH INC is a global IT and infrastructure provider registered in the USA and India, delivering next-generation cloud, AI, and DevOps solutions to enterprises worldwide.
            </p>
          </div>
        </div>

        {/* Mission */}
        <div className="py-20 md:py-28">
          <div className="w-full px-6 md:px-10 lg:px-16 xl:px-24">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#0052FF] mb-3">Our Mission</p>
                <h2 className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-[#0B132B] mb-6" style={{ fontFamily: 'Chivo, sans-serif' }}>
                  Empowering Enterprises Through Technology
                </h2>
                <p className="text-base leading-relaxed text-[#475569] mb-6" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
                  At the heart of our approach lies a commitment to revolutionizing IT operations through AIAURORA. Our journey began with the goal of empowering organizations with powerful infrastructure insights, leading to the development of our comprehensive cloud and AI solutions.
                </p>
                <p className="text-base leading-relaxed text-[#475569]" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>
                  Driven by innovation and a deep understanding of cloud technologies, we aim to reduce costs and enhance scalability. With our solutions, you only pay for what you use in the cloud, ensuring efficiency and cost-effectiveness.
                </p>
              </div>
              <div className="relative">
                <img
                  src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=600&h=400&fit=crop"
                  alt="Team collaboration"
                  className="w-full h-[400px] object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Values */}
        <div className="py-20 md:py-28 bg-[#F8FAFC]">
          <div className="w-full px-6 md:px-10 lg:px-16 xl:px-24">
            <div className="text-center mb-16">
              <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#0052FF] mb-3">Our Values</p>
              <h2 className="text-2xl sm:text-3xl lg:text-4xl tracking-tight font-bold text-[#0B132B]" style={{ fontFamily: 'Chivo, sans-serif' }}>
                What Drives Us
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {values.map((v) => (
                <div key={v.title} className="p-8 bg-white border border-slate-200 hover:border-[#0052FF]/30 transition-colors duration-200">
                  <div className="mb-5">{v.icon}</div>
                  <h3 className="text-xl font-semibold text-[#0B132B] mb-3" style={{ fontFamily: 'Chivo, sans-serif' }}>{v.title}</h3>
                  <p className="text-base leading-relaxed text-[#475569]" style={{ fontFamily: 'IBM Plex Sans, sans-serif' }}>{v.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
